export class InvalidSceneError extends Error {
    public name = "InvalidSceneError";
}
